import React from 'react';

const BlogEntrance = (props) => {
  return (
    <div>
      <h1>{props.blogData.title}</h1>
      <div className="ui text left aligned">
        <div dangerouslySetInnerHTML={{__html: JSON.parse(props.blogData.content)}}></div> 
      </div>
    </div>
  );
}

export default BlogEntrance;